import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface GaugeChartProps {
  value: number;
  max?: number;
  label?: string;
  height?: number | string;
  loading?: boolean;
  color?: string;
}

export function GaugeChart({ value, max = 100, label, height, loading, color }: GaugeChartProps) {
  const option: EChartsOption = {
    series: [
      {
        type: 'gauge',
        min: 0,
        max,
        progress: { show: true, width: 18 },
        axisLine: { lineStyle: { width: 18 } },
        pointer: { show: false },
        detail: {
          valueAnimation: true,
          formatter: label ? `{value}\n${label}` : '{value}',
          fontSize: 20,
        },
        data: [{ value }],
        itemStyle: color ? { color } : undefined,
      },
    ],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
